<template>
  <div class="loading" :aria-busy="true" />
</template>

<style scoped>
.loading {
  width: 100%;
  height: 100%;
}
</style>
